import React, { useState } from "react";
import styles from "./TransactionReceipt.module.scss";
import DownloadIconSVG from "components/SVGComponents/DownloadIconSVG";
import Trialbutton from "pages/PaymentPage/components/Trialbutton";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { downloadPdf, generateReceiptHTML } from "utils/pdfTemplateUtil";

const TransactionReceipt = ({ showReceipt = false }) => {
  const { activePlan } = useSelector((state) => state.payment);
  const navigate = useNavigate();
  const formattedDate =
    format(new Date(activePlan?.endDate ?? null), "MMM dd, yyyy") || "N/A";
  const [isLoading, setIsLoading] = useState(false);

  const handleDownloadProfile = () => {
    const onError = (error) => {
      console.error(error);
      setIsLoading(false);
    };

    const onSuccess = () => {
      setIsLoading(false);
    };
    setIsLoading(true);
    downloadPdf(
      generateReceiptHTML(activePlan, formattedDate),
      onSuccess,
      onError,
      { filename: `${activePlan.name || "Receipt"}.pdf`, isImages: false },
      500
    );
  };

  return (
    <section className={styles.paymentSection}>
      <div className={styles.rightSection}>
        <div className={styles.cardHeader}>
          <p>Your Receipt</p>
          <button onClick={handleDownloadProfile}>
            <DownloadIconSVG color="#000000" />
          </button>
        </div>
        <div className={styles.innerContainer}>
          <div className={styles.cardName}>
            <p>{activePlan?.name}</p>
            {/* <p>Get started with AI for Creatives</p> */}
          </div>
          <div className={styles.btnContainer}>
            {activePlan?.freeTrial && <Trialbutton />}
            <p>
              ₹{activePlan?.amount}
              <span>/{activePlan?.name}</span>
            </p>
          </div>
        </div>
        <div className={styles.transactionDetails}>
          <p>Transaction Details</p>
          <p>Transaction Id : {activePlan?.transactionId || "N/A"}</p>
          <p>Account Name : {activePlan?.username || "N/A"}</p>
          <hr />
        </div>
        <div className={styles.dueSection}>
          <div className={styles.leftDiagram}>
            <div className={styles.greyCircle}></div>
            <div className={styles.line}></div>
            <div className={styles.greyCircle}></div>
          </div>
          <div className={styles.rightPricing}>
            <div className={styles.btnContainer}>
              <p className={styles.thinText}>
                Due <br /> <span>15 days free trial start</span>
              </p>
              <p>
                {/* {activePlan?.amount} */}
                ₹0.00
                <span>/{activePlan?.name}</span>
              </p>
            </div>
            <div className={styles.btnContainer}>
              <p className={styles.thinText}>
                Due till <br /> <span>{formattedDate || "N/A"}</span>
              </p>
              <p>
                ₹{activePlan?.amount}
                <span>/{activePlan?.name}</span>
              </p>
            </div>
          </div>
        </div>
        {showReceipt && (
          <div className={styles.continue}>
            <button onClick={() => navigate("/feed")}>
              Continue
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default TransactionReceipt;
